import { render, staticRenderFns } from "./StrategyBlock.vue?vue&type=template&id=3531f9a2"
import script from "./StrategyBlock.vue?vue&type=script&lang=js"
export * from "./StrategyBlock.vue?vue&type=script&lang=js"
import style0 from "./StrategyBlock.vue?vue&type=style&index=0&id=3531f9a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports